import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class IntegrationEmail extends PrimitiveValueObject<string> {
  static create(value: string): IntegrationEmail {
    return new IntegrationEmail(value);
  }
}
